<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter1" id="c01"><a id="page9"></a><span href="#/OEBPS/toc#c01" title="Link target outside of Sample"><em>Sunday</em></span></h1>
<h1 class="chapter2"><span href="#/OEBPS/toc#c01" title="Link target outside of Sample"><strong>MARKETS</strong></span></h1>
<p class="pagebreak"> </p>
<div class="box_chapter">
<p class="box"><a id="page10"></a><em>Best</em></p>
<p class="center"><a href="#/OEBPS/c01_sec2">Coustellet <em>(farmers’ market)</em></a></p>
<p class="center1"><a href="#/OEBPS/c01_sec4">L’Isle-sur-la-Sorgue <em>(flea/antiques &amp; traditional Provençal market)</em></a></p>
<p class="center1"><span href="#/OEBPS/c01_sec7" title="Link target outside of Sample">Saint-Martin-de-la-Brasque <em>(farmers’ market)</em></span></p>
<p class="center1"><span href="#/OEBPS/c05_sec4" title="Link target outside of Sample">Avignon <em>(covered market)</em></span></p>
<p class="box"><em>Others</em></p>
<p class="center"><span href="#/OEBPS/c01_sec8" title="Link target outside of Sample">Aix-en-Provence <em>(monthly book market)</em></span></p>
<p class="center1"><span href="#/OEBPS/c01_sec9" title="Link target outside of Sample">Ansouis <em>(traditional Provençal market)</em></span></p>
<p class="center1"><span href="#/OEBPS/c01_sec10" title="Link target outside of Sample">Carpentras <em>(flea/antiques market)</em></span></p>
<p class="center1"><span href="#/OEBPS/c01_sec11" title="Link target outside of Sample">Châteaurenard <em>(traditional Provençal market)</em></span></p>
<p class="center1"><span href="#/OEBPS/c06_sec8" title="Link target outside of Sample">Nîmes <em>(covered market)</em></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c01.vue?958abf8e